import {
    maxLength,
    minCountNumbers, 
    minCountLowerChars, 
    minCountSpecialSigns, 
    minCountUpperChars,
    minLength
} from "@/scripts/Constants/PasswordConstraints";

const specialSignsRegex = /[ !@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/g;

const hasValidMaxLength = (password: string) => password.length <= maxLength;
const hasValidMinLength = (password: string) => password.length >= minLength;
const hasEnoughNumbers = (password: string) => (password.match(/\d/g) || []).length >= minCountNumbers;
const hasEnoughUpperCases = (password: string) => (password.match(/[A-Z]/g) || []).length >= minCountUpperChars;
const hasEnoughLowerCases = (password: string) => (password.match(/[a-z]/g) || []).length >= minCountLowerChars;
const hasEnoughSpecialSigns = (password: string) => (password.match(specialSignsRegex) || []).length >= minCountSpecialSigns;
const hasEqualPasswords = (newPassword: string, newPasswordConfirm: string) => newPassword === newPasswordConfirm;

export {
    hasValidMaxLength,
    hasValidMinLength,
    hasEnoughNumbers,
    hasEnoughUpperCases,
    hasEnoughLowerCases,
    hasEnoughSpecialSigns,
    hasEqualPasswords
}
